var angular = require('angular');
import licenseModule from '../../license.module';
import template from './licenseInstancesOverview.component.html';
import style from './licenseInstancesOverview.component.css';

export default licenseModule.component('licenseInstancesOverview', {
    template,
    style,
    controller: [
        'modalService',
        'entitlementConstants',
        licenseInstancesOverviewComponent
    ],
    bindToController: true,
    bindings: {
        instances: '<',
        showRegisterNewInstance: '<',
        callback: '&'
    }
});

function licenseInstancesOverviewComponent(modalService, entitlementConstants) {
    var vm = this;
    vm.$onChanges = change;
    vm.elements = [];
    vm.hasStaticOnPrem = false;

    function renderInstancesChart() {
        if (vm.instances != null) {
            vm.elements = [];

            for (var i = 0; i < vm.instances.length; i++) {
                var data = angular.copy(vm.instances[i]);

                var instance = {
                    id: data.id,
                    name: data.name,
                    serverDescription: data.serverDescription,
                    instanceType: data.instanceType,
                    online: data.online,
                    lastSync: data.lastSync,
                    expireDate: data.expireDate,
                    status: data.status,
                    country: data.country,
                    countryCode: data.countryCode,
                    serverProfile: data.serverProfile,
                    allocationType: data.allocationType,
                    labels: [
                        entitlementConstants.devices,
                        entitlementConstants.platformUsers
                    ],
                    usage: {
                        deviceId: data.usage.deviceId,
                        premiumUserId: data.usage.premiumUserId
                    },
                    allocated: {
                        subscription: {
                            deviceId: data.allocated.subscription.deviceId,
                            premiumUserId:
                                data.allocated.subscription.premiumUserId
                        },
                        perpetual: {
                            deviceId: data.allocated.perpetual.deviceId,
                            premiumUserId:
                                data.allocated.perpetual.premiumUserId
                        }
                    },
                    licenseStatus: data.licenseStatus,
                    deploymentType: data.deploymentType,
                    version: data.version
                };

                vm.elements.push(instance);

                if (vm.elements.length == 1) {
                    vm.noOfInstances = 'server';
                } else if (vm.elements.length > 1) {
                    vm.noOfInstances = 'servers';
                }
            }
        }
    }

    function change(changeObj) {
        if (
            changeObj.instances != undefined &&
            changeObj.instances.currentValue &&
            changeObj.instances.currentValue != null &&
            changeObj.instances.currentValue != undefined
        ) {
            renderInstancesChart();
        }
    }

    vm.openRegisterNewInstance = function() {
        modalService
            .openCustom({
                component: 'licenseRegisterNewInstance',
                size: 'lg',
                resolve: {
                    reset: true
                }
            })
            .then(
                function() {
                    vm.callback({ $value: 'close' });
                },
                function() {}
            );
    };

    vm.changes = function() {
        vm.callback({ $value: 'close' });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-instances-overview/licenseInstancesOverview.component.js